import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=bb9aa84a&scoped=true&"
import script from "./Admin.js?vue&type=script&lang=js&"
export * from "./Admin.js?vue&type=script&lang=js&"
import style0 from "./Admin.css?vue&type=style&index=0&id=bb9aa84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9aa84a",
  null
  
)

export default component.exports